import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { DidYouKnow } from "@learningblocks/simulations/shared-components";
import { Activity } from "@learningblocks/simulations/shared-components";
import { RectangleCard } from "@learningblocks/storybook-components";
import { NotebookImage } from "@learningblocks/simulations/shared-components";
import { HiddenComponent } from "@learningblocks/storybook-components";
import { StepSelectRedux } from "@learningblocks/storybook-components";
import { MultiSelectRedux } from "@learningblocks/simulations/shared-components";
import {
  SingleSelectRedux,
  QuestionTableRedux,
  OpenEndedRedux,
  OEQDisplay,
  QuestionMultiDropdown,
  ImageSelectionQuestionRedux,
} from "@learningblocks/simulations/shared-components";
import { SliderSelectRedux } from "@learningblocks/storybook-components";
import { Utilities } from "@learningblocks/exp-constants";
const { GLOSSARY_API_DETAILS, COMPONENT_TYPE } = Utilities;
import { SliderSelectGroupRedux } from "@learningblocks/storybook-components";
import { SingleSelectColorRedux } from "@learningblocks/storybook-components";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
import { SummaryText } from "@learningblocks/simulations/shared-components";
import { TakeawayMessages } from "@learningblocks/simulations/shared-components";
import { BlottingPaper } from "@learningblocks/simulations/shared-components";
import { ImageTable } from "@learningblocks/simulations/shared-components";
import { TextArea } from "@learningblocks/simulations/shared-components";
import { MaterialSection } from "@learningblocks/simulations/shared-components";
import { ContextTable } from "@learningblocks/simulations/shared-components";
import { GelComponent } from "@learningblocks/protocol-components/lib/GelComponent";
import { RestrictionDigestPredictions } from "@learningblocks/protocol-components/lib/RestrictionDigestPredictions";
import { RestrictionDigestResults } from "@learningblocks/protocol-components/lib/RestrictionDigestResults";
import Predictions46 from "@learningblocks/protocol-components/lib/Predictions46";
import Results46 from "@learningblocks/protocol-components/lib/Results46";
import PredictionsChoiceQuestion from "@learningblocks/protocol-components/lib/PredictionsChoiceQuestion";
import Predictions510 from "@learningblocks/protocol-components/lib/Predictions510";
import GelResults510 from "@learningblocks/protocol-components/lib/GelResults510";
import ControlResults510 from "@learningblocks/protocol-components/lib/ControlResults510";
import { ConditionalDisplay } from "@learningblocks/simulations/shared-components";
import GelResults512 from "@learningblocks/protocol-components/lib/GelResults512";
import { TransformingBacteriaPredictions } from "@learningblocks/protocol-components/lib/TransformingBacteriaPredictions";
import { TransformingBacteriaResults } from "@learningblocks/protocol-components/lib/TransformingBacteriaResults";
import { Ideal57 } from "@learningblocks/protocol-components/lib/TransformingBacteriaIdeal";
import Predictions37 from "@learningblocks/protocol-components/lib/Predictions37";
import PredictionResults37 from "@learningblocks/protocol-components/lib/PredictionResults37";
import { AssayPredictions } from "@learningblocks/protocol-components/lib/AssayPredictions";
import { AssayExperimentalDesign } from "@learningblocks/protocol-components/lib/AssayExperimentalDesign";
import { AssayResultsTable } from "@learningblocks/protocol-components/lib/AssayResultsTable";
import { AssayGelResults } from "@learningblocks/protocol-components/lib/AssayGelResults";
import { ResultsQuestionResult } from "@learningblocks/protocol-components/lib/ResultsQuestionResult";

import Predictions59 from "@learningblocks/protocol-components/lib/Predictions59";
import { PredictionQuestions59 } from "@learningblocks/protocol-components/lib/PredictionQuestions59";
import Results59 from "@learningblocks/protocol-components/lib/Results59";
import ResultsQuestions59 from "@learningblocks/protocol-components/lib/ResultsQuestions59";

import SeparateProteinPredictions from "@learningblocks/protocol-components/lib/SeparateProteinPredictions";
import SeparateProteinResults from "@learningblocks/protocol-components/lib/SeparateProteinResults";
import MatchingQuestion from "@learningblocks/protocol-components/lib/MatchingQuestion";
import MatchingQuestionResults from "@learningblocks/protocol-components/lib/MatchingQuestionResults";
import { DataTable } from "@learningblocks/shared-components";
import { ColorPredictionRedux } from "@learningblocks/simulations/shared-components";
import {
  NoteBanner,
  MicroplateReadout1Redux,
  MicroplateReadout2Redux,
} from "@learningblocks/storybook-components";
import {
  getIndividialDataFromAirtable,
  getIndividualGlossaryItem,
} from "@learningblocks/exp-constants/lib/Utilities";
import { GlossaryProvider } from "@learningblocks/storybook-components";
import {
  ResultsComparisonPhotosynthesis,
  ResultsComparisonImages,
  ResultsComparisonMicroscopeRedux,
  ResultsComparisonChartsRedux,
} from "@learningblocks/simulations/shared-components";
import { FullWidthAnimation } from "@learningblocks/simulations/shared-components/lib/FullWidthAnimation";
import { SliderImage } from "@learningblocks/simulations/shared-components";
import { SliderWidgetContainer } from "@learningblocks/storybook-components";
import { PlotSingleSelect } from "@learningblocks/simulations/shared-components";
import { Banner } from "@learningblocks/simulations/shared-components";
import { Collapsible } from "@labxchange/ui-components/lib/LxCollapsible";
import { TableQuestion } from "@labxchange/ui-components/lib/TableQuestion";
import { BodyText } from "@labxchange/ui-components/lib/BodyText";
import { Figure } from "@labxchange/ui-components/lib/Figure";
import { SpecialTextBox } from "@labxchange/ui-components/lib/SpecialTextBox";
import { Heading } from "@labxchange/ui-components/lib/Heading";

import {
  DialysisConcentrationToggle,
  DialysisDragDropQuestion,
  ResultsComparisonDialysis,
  DataTableRandomiser,
  Equation,
  DialysisSingleSelect,
} from "@learningblocks/protocol-components";

/**
 * ContentComponents:
 *  - Display the contents of all Sections Except for DesignSection
 *    in Web View
 */
export function ContentComponents({
  components,
  className,
  simSpecificComponentMap,
  usingNewDesignSystem,
}) {
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  const getGlossaryItem = () =>
    getIndividualGlossaryItem(
      getIndividialDataFromAirtable,
      GLOSSARY_API_DETAILS.URL,
      GLOSSARY_API_DETAILS.KEY
    );

  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const plainText = (component) => {
    return <RichText key={component.id} className={className} {...component} />;
  };

  const conditionalDisplay = (component) => {
    return <ConditionalDisplay key={component.id} {...component} />;
  };

  const fullWidthImage = (component) => (
    <NotebookImage {...component} key={component.id} className={className} />
  );

  // Todo: Revisit Slider Image Logic and Move this related functions to proper file

  const singleSelect = (component) => (
    <SingleSelectRedux
      {...component}
      key={component.id}
      className={className}
    />
  );

  const imageSelectionQuestion = (component) => (
    <ImageSelectionQuestionRedux {...component} key={component.id} />
  );

  const multiSelect = (component) => (
    <MultiSelectRedux {...component} key={component.id} className={className} />
  );

  const stepSelect = (component) => {
    const options = component.options.map((option) => {
      return { value: option.id, label: option.text };
    });

    return (
      <StepSelectRedux
        {...component}
        key={component.id}
        className={className}
        options={options}
      />
    );
  };

  const sliderSelect = (component) => (
    <SliderSelectRedux
      {...component}
      key={component.id}
      className={className}
    />
  );

  const sliderWidget = (component) => (
    <SliderWidgetContainer
      {...component}
      key={component.id}
      className={className}
    />
  );

  const sliderSelectGroup = (component) => (
    <SliderSelectGroupRedux
      {...component}
      key={component.id}
      className={className}
    />
  );

  const singleSelectColorRedux = (component) => (
    <SingleSelectColorRedux
      {...component}
      key={component.id}
      className={className}
    />
  );

  const materialSection = (component) => {
    return <MaterialSection {...component} key={component.id} />;
  };

  const techniqueCard = (component) => {
    const MOBILE_WIDTH = 767;
    const currentScreenWidth = document.body.clientWidth;
    const trim = currentScreenWidth > MOBILE_WIDTH ? false : true;
    return (
      <RectangleCard
        {...component}
        key={component.id}
        className={className}
        trim={trim}
      />
    );
  };

  const summaryText = (component) => (
    <SummaryText key={component.id} {...component} />
  );

  const takeawayMessages = (component) => (
    <TakeawayMessages key={component.id} {...component} />
  );

  const blottingPaper = (component) => (
    <BlottingPaper key={component.id} {...component} />
  );

  const imageTable = (component) => (
    <ImageTable key={component.id} {...component} />
  );

  const textArea = (component) => (
    <TextArea key={component.id.toString()} {...component} />
  );

  const contextTable = (component) => (
    <ContextTable key={component.id} {...component} />
  );

  const gelComponent = (component) => (
    <GelComponent key={component.id} {...component} />
  );

  const restrictionDigestPredictions = (component) => (
    <RestrictionDigestPredictions key={component.id} {...component} />
  );

  const restrictionDigestResults = (component) => (
    <RestrictionDigestResults key={component.id} {...component} />
  );

  const predictions46 = (component) => (
    <Predictions46 key={component.id} {...component} />
  );

  const results46 = (component) => (
    <Results46 key={component.id} {...component} />
  );

  const predictionsChoiceQuestion = (component) => (
    <PredictionsChoiceQuestion key={component.id} {...component} />
  );

  const predictions510 = (component) => (
    <Predictions510 key={component.id} {...component} />
  );

  const gelResults510 = (component) => (
    <GelResults510 key={component.id} {...component} />
  );

  const controlResults510 = (component) => (
    <ControlResults510 key={component.id} {...component} />
  );

  const gelResults512 = (component) => (
    <GelResults512 key={component.id} {...component} />
  );

  const transformBacteriaPredictions = (component) => (
    <TransformingBacteriaPredictions key={component.id} {...component} />
  );

  const transformBacteriaResults = (component) => (
    <TransformingBacteriaResults key={component.id} {...component} />
  );

  const ideal57 = (component) => <Ideal57 key={component.id} {...component} />;

  const ligatingDNAPredictions = (component) => (
    <Predictions37 key={component.id} {...component} />
  );

  const ligatingDNAResults = (component) => (
    <PredictionResults37 key={component.id} {...component} />
  );

  const assayPredictions = (component) => (
    <AssayPredictions key={component.id} {...component} />
  );

  const assayExperimentalDesign = (component) => (
    <AssayExperimentalDesign key={component.id} {...component} />
  );

  const assayResultsTable = (component) => (
    <AssayResultsTable key={component.id} {...component} />
  );

  const assayGelResults = (component) => (
    <AssayGelResults key={component.id} {...component} />
  );

  const resultsQuestionResult = (component) => (
    <ResultsQuestionResult key={component.id} {...component} />
  );

  const predictions59 = (component) => (
    <Predictions59 key={component.id} {...component} />
  );

  const predictionQuestions59 = (component) => (
    <PredictionQuestions59 key={component.id} {...component} />
  );

  const results59 = (component) => (
    <Results59 key={component.id} {...component} />
  );

  const resultsQuestions59 = (component) => (
    <ResultsQuestions59 key={component.id} {...component} />
  );

  const separateProteinPredictions = (component) => (
    <SeparateProteinPredictions key={component.id} {...component} />
  );

  const separateProteinResults = (component) => (
    <SeparateProteinResults key={component.id} {...component} />
  );

  const matchingQuestion = (component) => (
    <MatchingQuestion key={component.id} {...component} />
  );

  const matchingQuestionResults = (component) => (
    <MatchingQuestionResults key={component.id} {...component} />
  );

  const plotSingleSelect = (component) => (
    <PlotSingleSelect key={component.id} className={className} {...component} />
  );

  const colorPredictionQuestion = (component) => (
    <ColorPredictionRedux key={component.id} {...component} />
  );

  const notebookBanner = (component) => (
    <NoteBanner
      title={component.title}
      text={component.banner}
      openGlossary={onOpenGlossary}
      getContentData={getGlossaryItem()}
    />
  );

  const simulationBanner = (component) => {
    const onClickHighlight = (contentId, event) => {
      if (contentId === "glossary") {
        onOpenGlossary(contentId, event);
      } else {
        onPlainTextClick(contentId, event);
      }
    };
    return (
      <div style={{ marginTop: "24px" }}>
        <Banner
          title={component.title}
          text={component.banner}
          key={component.id}
          onClickHighlight={onClickHighlight}
        />
      </div>
    );
  };

  const questionTable = (component) =>
    usingNewDesignSystem ? (
      <TableQuestion key={component.id} {...component} />
    ) : (
      <QuestionTableRedux
        key={component.id}
        {...component}
        className={className}
      />
    );

  const fullWidthAnimation = (component) => (
    <FullWidthAnimation key={component.id} {...component} />
  );

  const resultsComparisonPhotosynthesis = (component) => (
    <ResultsComparisonPhotosynthesis key={component.id} {...component} />
  );

  const resultsComparisonImages = (component) => (
    <ResultsComparisonImages key={component.id} {...component} />
  );

  const resultsComparisonMicroscope = (component) => (
    <ResultsComparisonMicroscopeRedux key={component.id} {...component} />
  );

  const resultsComparisonCharts = (component) => (
    <ResultsComparisonChartsRedux key={component.id} {...component} />
  );

  const dialysisConcentrationToggle = (component) => (
    <DialysisConcentrationToggle key={component.id} {...component} />
  );

  const dialysisDragDropQuestion = (component) => (
    <DialysisDragDropQuestion key={component.id} {...component} />
  );

  const resultsComparisonDialysis = (component) => (
    <ResultsComparisonDialysis key={component.id} {...component} />
  );

  const dataTableRandomiser = (component) => (
    <DataTableRandomiser key={component.id} {...component} />
  );

  const equation = (component) => (
    <Equation key={component.id} {...component} />
  );

  const dialysisSingleSelect = (component) => (
    <DialysisSingleSelect
      key={component.id}
      {...component}
      className={className}
    />
  );

  const dataTable = (component) => (
    <DataTable key={component.id} {...component} />
  );

  const microplateReadout2 = () => <MicroplateReadout2Redux />;

  const microplateReadout1 = () => <MicroplateReadout1Redux />;

  const openEnded = (component) => (
    <OpenEndedRedux {...component} key={component.id} className={className} />
  );

  const oeqDisplay = (component) => (
    console.log("Rendering OEQDisplay with component:", component),
    (<OEQDisplay component={component} key={component.id} />)
  );

  const didYouKnow = (component) => (
    <DidYouKnow {...component} key={component.id} className={className} />
  );

  const activity = (component) => (
    <Activity {...component} key={component.id} className={className} />
  );

  const multiSelectDropdown = (component) => (
    <QuestionMultiDropdown key={component.id} {...component} />
  );

  const collapsible = (component) => {
    // Handle different content types within the collapsible
    // Supports: content only, single additional component, or array of items
    let additionalComponent = null;

    if (component.contentType === "question_table" && component.contentData) {
      additionalComponent = (
        <QuestionTableRedux
          key={`${component.id}-table`}
          {...component.contentData}
        />
      );
    }

    if (component.contentType === "DataTable" && component.contentData) {
      additionalComponent = (
        <DataTable
          key={`${component.id}-data-table`}
          {...component.contentData}
        />
      );
    }

    if (component.contentType === "image" && component.contentData) {
      additionalComponent = (
        <Figure
          key={`${component.id}-image`}
          {...component.contentData.image}
          className={className}
        />
      );
    }

    // Support array of items (text, images, and animations in sequence)
    if (component.contentType === "items" && component.contentItems) {
      const items = component.contentItems.map((item, index) => {
        if (item.type === "text") {
          return (
            <RichText
              key={`${component.id}-text-${index}`}
              value={item.value}
            />
          );
        } else if (item.type === "image") {
          return (
            <Figure
              key={`${component.id}-image-${index}`}
              {...item.image}
              className={className}
            />
          );
        } else if (item.type === "animation") {
          return (
            <FullWidthAnimation
              key={`${component.id}-animation-${index}`}
              {...item}
            />
          );
        }
        return null;
      });

      return (
        <Collapsible
          key={component.id}
          label={component.label}
          content={<>{items}</>}
          variant={component.variant ?? "box"}
          open={component.open || false}
        />
      );
    }

    const contentToRender = (
      <>
        <RichText value={component.content} />
        {additionalComponent}
      </>
    );

    return (
      <Collapsible
        key={component.id}
        label={component.label}
        content={contentToRender}
        open={component.open || false}
        variant={component.variant ?? "box"}
      />
    );
  };

  const bodyText = (component) => {
    return <BodyText key={component.id} {...component} />;
  };

  const figure = (component) => {
    return <Figure key={component.id} {...component} />;
  };

  const specialTextBox = (component) => {
    return <SpecialTextBox key={component.id} {...component} />;
  };

  const heading = (component) => {
    return <Heading key={component.id} {...component} />;
  };

  const renderComponent = (component) => {
    switch (component.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return plainText(component);
      case COMPONENT_TYPE.MSCQ_DDQ:
        return multiSelectDropdown(component);
      case COMPONENT_TYPE.CONDITIONAL_DISPLAY:
        return conditionalDisplay(component);
      case COMPONENT_TYPE.SLIDER_IMAGE:
        return <SliderImage {...component} />;
      case COMPONENT_TYPE.SLIDER_WIDGET:
        return sliderWidget(component);
      case COMPONENT_TYPE.COLOR_PREDICTION:
        return colorPredictionQuestion(component);
      case COMPONENT_TYPE.BANNER:
        return notebookBanner(component);
      case COMPONENT_TYPE.SIM_BANNER:
        return simulationBanner(component);
      case COMPONENT_TYPE.QUESTION_TABLE:
        return questionTable(component);
      case COMPONENT_TYPE.RESULT_COMPARISON_PHOTOSYNTHESIS:
        return resultsComparisonPhotosynthesis(component);
      case COMPONENT_TYPE.RESULT_COMPARISON_IMAGES:
        return resultsComparisonImages(component);
      case COMPONENT_TYPE.RESULT_COMPARISON_CHARTS:
        return resultsComparisonCharts(component);
      case COMPONENT_TYPE.FULL_WIDTH_ANIMATION:
        return fullWidthAnimation(component);
      case COMPONENT_TYPE.TEXT_AREA:
        return textArea(component);
      case COMPONENT_TYPE.TECHNIQUE_CARD:
        return techniqueCard(component);
      case COMPONENT_TYPE.NOTEBOOK_IMAGE:
        return fullWidthImage(component);
      case COMPONENT_TYPE.SUMMARY_TEXT:
        return summaryText(component);
      case COMPONENT_TYPE.TAKEAWAY_MESSAGES:
        return takeawayMessages(component);
      case COMPONENT_TYPE.MATERIAL_SECTION:
        return materialSection(component);
      case COMPONENT_TYPE.BLOTTING_PAPER:
        return blottingPaper(component);
      case COMPONENT_TYPE.IMAGE_TABLE:
        return imageTable(component);
      case COMPONENT_TYPE.CONTEXT_TABLE:
        return contextTable(component);
      case COMPONENT_TYPE.GEL_COMPONENT:
        return gelComponent(component);
      case COMPONENT_TYPE.RESTRICTION_DIGEST_PREDICTIONS:
        return restrictionDigestPredictions(component);
      case COMPONENT_TYPE.RESTRICTION_DIGEST_RESULTS:
        return restrictionDigestResults(component);
      case COMPONENT_TYPE.RECOMBINANT_PLASMID_PREDICTIONS:
        return predictions46(component);
      case COMPONENT_TYPE.RECOMBINANT_PLASMID_RESULTS:
        return results46(component);
      case COMPONENT_TYPE.PREDICTIONS_510:
        return predictions510(component);
      case COMPONENT_TYPE.PREDICTIONS_CHOICE_QUESTION:
        return predictionsChoiceQuestion(component);
      case COMPONENT_TYPE.GEL_RESULTS_510:
        return gelResults510(component);
      case COMPONENT_TYPE.CONTROL_RESULTS_510:
        return controlResults510(component);
      case COMPONENT_TYPE.GEL_RESULTS_512:
        return gelResults512(component);
      case COMPONENT_TYPE.TRANSFORMING_BACTERIA_PREDICTIONS:
        return transformBacteriaPredictions(component);
      case COMPONENT_TYPE.TRANSFORMING_BACTERIA_RESULTS:
        return transformBacteriaResults(component);
      case COMPONENT_TYPE.TRANSFORMING_BACTERIA_IDEAL:
        return ideal57(component);
      case COMPONENT_TYPE.LIGATING_DNA_PREDICTIONS:
        return ligatingDNAPredictions(component);
      case COMPONENT_TYPE.LIGATING_DNA_RESULTS:
        return ligatingDNAResults(component);
      case COMPONENT_TYPE.DNA_CLEAVAGE_ASSAY_PREDICTIONS:
        return assayPredictions(component);
      case COMPONENT_TYPE.DNA_CLEAVAGE_ASSAY_EXPERIMENTAL_DESIGN:
        return assayExperimentalDesign(component);
      case COMPONENT_TYPE.DNA_CLEAVAGE_ASSAY_RESULTS:
        return assayResultsTable(component);
      case COMPONENT_TYPE.DNA_CLEAVAGE_ASSAY_GEL_RESULTS:
        return assayGelResults(component);
      case COMPONENT_TYPE.QUESTION_RESULT:
        return resultsQuestionResult(component);
      case COMPONENT_TYPE.PLATING_TRANSFORMED_BACTERIA_PREDICTIONS:
        return predictions59(component);
      case COMPONENT_TYPE.PREDICTION_QUESTIONS_59:
        return predictionQuestions59(component);
      case COMPONENT_TYPE.RESULTS59:
        return results59(component);
      case COMPONENT_TYPE.RESULTS_QUESTIONS_59:
        return resultsQuestions59(component);
      case COMPONENT_TYPE.SEPARATE_PROTEIN_PREDICTIONS:
        return separateProteinPredictions(component);
      case COMPONENT_TYPE.SEPARATE_PROTEIN_RESULTS:
        return separateProteinResults(component);
      case COMPONENT_TYPE.MATCHING_QUESTION:
        return matchingQuestion(component);
      case COMPONENT_TYPE.MATCHING_QUESTION_RESULTS:
        return matchingQuestionResults(component);
      case COMPONENT_TYPE.PLOT_CSCQ:
        return plotSingleSelect(component);
      case COMPONENT_TYPE.OEQ:
        return openEnded(component);
      case COMPONENT_TYPE.OEQ_DISPLAY:
        return oeqDisplay(component);
      case COMPONENT_TYPE.DIALYSIS_CONCENTRATION_TOGGLE:
        return dialysisConcentrationToggle(component);
      case COMPONENT_TYPE.DIALYSIS_SINGLE_SELECT:
        return dialysisSingleSelect(component);
      case COMPONENT_TYPE.DIALYSIS_DRAG_DROP_QUESTION:
        return dialysisDragDropQuestion(component);
      case COMPONENT_TYPE.RESULT_COMPARISON_DIALYSIS:
        return resultsComparisonDialysis(component);
      case COMPONENT_TYPE.DATA_TABLE_RANDOMISER:
        return dataTableRandomiser(component);
      case COMPONENT_TYPE.EQUATION:
        return equation(component);
      case COMPONENT_TYPE.CSCQ:
        return singleSelect(component);
      case COMPONENT_TYPE.IMAGE_SELECTION_QUESTION:
        return imageSelectionQuestion(component);
      case COMPONENT_TYPE.MSCQ:
        return multiSelect(component);
      case COMPONENT_TYPE.DDQ:
        return stepSelect(component);
      case COMPONENT_TYPE.DIDYOUKNOW:
        return didYouKnow(component);
      case COMPONENT_TYPE.ACTIVITY:
        return activity(component);
      case COMPONENT_TYPE.GROUPED_DNDQ:
        return (
          <HiddenComponent
            visibility={component.visibility}
            key={component.id}
            className={className}
          >
            {sliderSelectGroup(component)}
          </HiddenComponent>
        );
      case COMPONENT_TYPE.DNDQ_COLOR:
        return (
          <HiddenComponent
            visibility={component.visibility}
            key={component.id}
            className={className}
          >
            {sliderSelect(component)}
          </HiddenComponent>
        );
      case COMPONENT_TYPE.CSCQ_COLOR:
        return (
          <HiddenComponent
            visibility={component.visibility}
            key={component.id}
            className={className}
          >
            {singleSelectColorRedux(component)}
          </HiddenComponent>
        );

      case COMPONENT_TYPE.DATA_TABLE:
        return dataTable(component);
      case COMPONENT_TYPE.MICROPLATE_READOUT1:
        return microplateReadout1();
      case COMPONENT_TYPE.MICROPLATE_READOUT2:
        return microplateReadout2();
      case COMPONENT_TYPE.RESULTS_COMPARISON_MICROSCOPE:
        return resultsComparisonMicroscope(component);
      // new design system components
      case COMPONENT_TYPE.BODY_TEXT:
        return bodyText(component);
      case COMPONENT_TYPE.COLLAPSIBLE:
        return collapsible(component);
      case COMPONENT_TYPE.FIGURE:
        return figure(component);
      case COMPONENT_TYPE.SPECIAL_TEXT_BOX:
        return specialTextBox(component);
      case COMPONENT_TYPE.HEADING:
        return heading(component);
      default:
        return <h3> Component Type {component.type}</h3>;
    }
  };

  const componentList = [];

  for (const index in components) {
    const component = components[index];
    const renderedComponent =
      simSpecificComponentMap?.[component.type]?.(component) ||
      renderComponent(component);
    componentList.push(renderedComponent);
    if (component && component.finalPoint) {
      break;
    }
  }

  return <>{componentList}</>;
}

ContentComponents.propTypes = {
  /**
   * Array of data corresponding to component to be
   * displayed in content
   */
  components: PropTypes.arrayOf(PropTypes.object),
  /**
   * ClassName to set on each component in List
   */
  className: PropTypes.string,
  /**
   * Flag to indicate if the new design system is being used
   */
  usingNewDesignSystem: PropTypes.bool,
};

ContentComponents.defaultProps = {
  usingNewDesignSystem: false,
};
